// extracted by mini-css-extract-plugin
export default {"svg--hidden":"Sprite_svg--hidden__uWQPz","svg-logo":"Sprite_svg-logo__eChxd"};